import { AxiosResponse } from 'axios';
import { useQuery, useMutation } from 'react-query';
import apiClient from '../apiClient/apiClient';
import {AddEditClassRequestBody, Class } from './class.types';

/**
 *
 * @param enabled boolean
 * @param status number - filters by statusNo
 * @returns Class[]
 */
export const useClasses = (enabled: boolean = false, status?: number) => {
  return useQuery<AxiosResponse<Class[]>>({
    queryKey: ['classes', status],
    queryFn: () => apiClient.get<Class[]>('/classes', { params: { status } }),
    enabled,
  });
};

export const useClass = (requestBody: { classNo: string }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<Class>>({
    queryKey: ['class', requestBody.classNo],
    queryFn: () => apiClient.get<Class>(`/classes/${requestBody.classNo}`, { params: requestBody }),
    enabled,
  });
};

export const useEditClass = (classNo: string) => {
  return useMutation((requestBody: AddEditClassRequestBody) => {
    return apiClient.put(`/classes/${classNo}`, requestBody);
  });
};

export const useAddClass = () => {
  return useMutation((requestBody: AddEditClassRequestBody) => {
    return apiClient.post(`/classes`, requestBody);
  });
};

export const useGetMenuItemRecipeClasses = (
    menuNo: string,
    requestBody: { strategyNo?: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Class[]>>({
    queryKey: ['getMenuItemRecipeClasses', menuNo, requestBody.strategyNo],
    queryFn: () => apiClient.get<Class[]>(`/menus/${menuNo}/items/recipes/classes`, { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemSubRecipeClasses = (
    menuNo: string,
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Class[]>>({
    queryKey: ['getMenuItemSubRecipeClasses', menuNo],
    queryFn: () => apiClient.get<Class[]>(`/menus/${menuNo}/items/sub-recipes/classes`),
    enabled
  });
};
